// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-content[data-v-27047184]{padding-bottom:0.24rem}.tab-content li[data-v-27047184]{display:inline-block;padding:0 0.18rem 0.1rem;cursor:pointer;margin-right:0.24rem}.tab-content .active[data-v-27047184]{border-bottom:0.04rem solid #e31d33}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
